try {
  require('./iconography.css');
} catch(e) {
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/pui-css-iconography/index.js
// module id = 806
// module chunks = 0